import _ from 'lodash';

import SetupApi from '@/store/api/system/setup';
import store from '@/store'
import pinia from '@/pinia';
import { useAuthStore } from '@/stores';

export default {
    get(key = null, context = 'cms') {
        // const cms = _.get(store, 'getters.activeCms.id') || SetupApi.getActiveCmsId();
        // if (!cms) return null;

        const authStore = useAuthStore(pinia);
        // The REAL person's clipboard, through a support session and out of it.
        const userId = authStore.actingUserId;
        if (!userId) return null;

        if (context === 'cms') {
            const cms = _.get(store, 'getters.activeCms.id') || SetupApi.getActiveCmsId();
            if (!cms) return null;
            context = `cms:${cms}`
        }

        let clipboard = JSON.parse(localStorage.getItem(`clipboard:${userId}`));
        if (key && clipboard) clipboard = _.get(clipboard, `${context}.${key}`)

        return clipboard;
    },
    set(key, value, context = 'cms') {
        // const cms = _.get(store, 'getters.activeCms.id') || SetupApi.getActiveCmsId();
        // if (!cms) return null;

        const authStore = useAuthStore(pinia);
        // The REAL person's clipboard, through a support session and out of it.
        const userId = authStore.actingUserId;
        if (!userId) return null;

        if (context === 'cms') {
            const cms = _.get(store, 'getters.activeCms.id') || SetupApi.getActiveCmsId();
            if (!cms) return null;
            context = `cms:${cms}`
        }

        let clipboard = this.get() || {};
        clipboard = _.set(clipboard, `${context}.${key}`, value);
        localStorage.setItem(`clipboard:${userId}`, JSON.stringify(clipboard));

        return clipboard;
    },
    remove(key, context = 'cms') {
        // const cms = _.get(store, 'getters.activeCms.id') || SetupApi.getActiveCmsId();
        // if (!cms) return null;

        const authStore = useAuthStore(pinia);
        // The REAL person's clipboard, through a support session and out of it.
        const userId = authStore.actingUserId;
        if (!userId) return null;

        if (context === 'cms') {
            const cms = _.get(store, 'getters.activeCms.id') || SetupApi.getActiveCmsId();
            if (!cms) return null;
            context = `cms:${cms}`
        }

        let clipboard = this.get();
        const value = _.get(clipboard, `${context}.${key}`);
        if (value !== undefined) delete clipboard[context][key]
        localStorage.setItem(`clipboard:${userId}`, JSON.stringify(clipboard));

        return clipboard;
    }
};
